import { useMutation } from "@connectrpc/connect-query";
import { ReservationService } from "@viajero/proto/guest/v1";

/**
 * ReservationService.RequestEmailVerification を connect-query mutation でラップするフック。
 *
 * 「メールアドレス認証」押下・コード再送で 6 桁コードを発行・送信する (§6.4)。
 * 認証は案件に紐付き予約 ID は不要 (JPTP_CANSEI-1678)。同一案件への再送は backend が 60 秒間抑止し
 * ResourceExhausted を返す (§5.1)。
 */
export function useRequestEmailVerification() {
  return useMutation(ReservationService.method.requestEmailVerification);
}
